import {
  Configuration as MsalConfiguration,
  PublicClientApplication,
} from "@azure/msal-browser";

import { Configuration } from "./configuration";

const msalConfiguration: MsalConfiguration = {
  auth: {
    clientId: Configuration.azureClientId,
    authority: `https://login.microsoftonline.com/${Configuration.azureTenantId}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: "sessionStorage",
  },
};

export const msalInstance = new PublicClientApplication(msalConfiguration);

/**
 * Scopes requested when acquiring an access token (GraphQL Bearer + group claims).
 * Audience is this SPA's Entra app registration (access_as_user); infra emits
 * security groups on that access token.
 */
export const apiTokenRequest = {
  scopes: [Configuration.apiScope],
};

/**
 * Scopes requested at interactive login. Include the API scope so consent
 * happens once (admin-consented by infra).
 */
const loginBaseScopes = ["openid", "profile", "email"];
export const loginRequest = {
  scopes: Configuration.apiScope
    ? [...loginBaseScopes, Configuration.apiScope]
    : loginBaseScopes,
};
